<template>
    <div>
        <label for="transporte">Transporte</label>
        <select @input="$emit('input', $event.target.value)" required="required" name="transporte" id="transporte">
            <option :value="dato.name"
                    v-for="dato in data"
                    :id="dato.id"
            >{{dato.name}}</option>
        </select>
        <i class="bar"></i>
    </div>
</template>

<script>
    export default {
        name: "Transporte",
        props: {
            data:{type:Array},
            value:{type:String}
        },
        data(){
            return{

            }
        }
    }
</script>

<style scoped>
    label{
        font-weight: bold;
        display: block;
    }
    select{
        cursor: pointer;
    }
</style>
